<template>
  <LibraryListItem :class="{ 'pl-4': !showCheckbox }">
    <DpplSimpleCheckbox
      v-if="showCheckbox"
      :model-value="selected"
      :option="{ id: ulid, label: `Select ${title || 'profile'}` }"
      hide-label
      size="md"
      border-radius="6px"
      class="checkbox document-checkbox"
      @click.stop
      @update:model-value="$emit('update:selected', $event)"
    />

    <div class="document-title text-textDarkest">
      {{ title }}
    </div>

    <BasicCellWithTooltip :text="jobCode" />
    <BasicCellWithTooltip :text="jobLevel" />
    <BasicCellWithTooltip :text="department" />
    <BasicCellWithTooltip :text="status" />
    <BasicCellWithTooltip :text="lastRevisedAt" />
  </LibraryListItem>
</template>

<script setup>
import { computed } from 'vue';
import LibraryListItem from '@/components/shared/LibraryListItem.vue';
import BasicCellWithTooltip from '@/components/jobProfiles/profileListItemCells/BasicCellWithTooltip.vue';
import DpplSimpleCheckbox from '@/components/datapeople/DpplSimpleCheckbox.vue';

const props = defineProps({
  ulid: { type: String, default: '' },
  title: { type: String, default: '' },
  jobCode: { type: String, default: '' },
  jobLevel: { type: String, default: '' },
  department: { type: String, default: '' },
  isArchived: { type: Boolean, default: false },
  lastRevised: { type: String, default: '' },
  selected: { type: Boolean, default: false },
  showCheckbox: { type: Boolean, default: false },
});

defineEmits(['update:selected']);

const status = computed(() => (props.isArchived ? 'Archived' : 'Public'));

const lastRevisedAt = computed(
  () => (props.lastRevised ? new Date(props.lastRevised).toLocaleDateString('en-US') : ''),
);
</script>

<style lang="less" scoped>
.document-list-item {
  grid-template-columns: repeat(2, 1fr);
}

.document-title {
  font-size: 15px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.document-checkbox {
  justify-self: center;
}
</style>
